import script from "./ModernAgentGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernAgentGrid.vue?vue&type=script&setup=true&lang=js"

import "./ModernAgentGrid.vue?vue&type=style&index=0&id=8ed9f1bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed9f1bc"]])

export default __exports__